export default "__VITE_PUBLIC_ASSET__e2eab0e9__"